function Loading() {
  return <>Loading</>;
}

export default Loading;
